var _path, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmsIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0272 0C15.035 0 16.0387 0 17.1195 0.341667C18.2995 0.771167 19.2288 1.7005 19.6583 2.8805C20 3.96117 20 4.96517 20 6.97283V13.0272C20 15.035 20 16.0387 19.6583 17.1195C19.2288 18.2995 18.2995 19.2288 17.1195 19.6582C16.0387 20 15.035 20 13.0272 20H6.97283C4.965 20 3.96117 20 2.8805 19.6582C1.7005 19.2288 0.771167 18.2995 0.341667 17.1195C0 16.0387 0 15.035 0 13.0272V6.97283C0 4.96517 0 3.96117 0.341667 2.8805C0.771167 1.7005 1.7005 0.771167 2.8805 0.341667C3.96117 0 4.965 0 6.97283 0H13.0272Z",
    fill: "url(#paint0_linear_2444_5064)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3333 9.74999C17.3333 13.1097 14.0501 15.8333 9.99999 15.8333C9.51022 15.8333 9.03167 15.7935 8.56878 15.7175C8.16095 15.678 7.9188 15.7158 7.5008 15.8451C7.34624 15.8929 7.16567 15.9894 6.95873 16.1001C6.49513 16.348 5.89916 16.6667 5.16665 16.6667C5.15285 16.6667 5.19925 16.6207 5.27867 16.5421C5.54165 16.2816 6.16665 15.6628 6.16665 15.1667V14.937C4.06695 13.8669 2.66666 11.9441 2.66666 9.74999C2.66666 6.39026 5.9499 3.66666 9.99999 3.66666C14.0501 3.66666 17.3333 6.39026 17.3333 9.74999Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2444_5064",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 20,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#67FF81"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01B41F"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmsIcon);
export default __webpack_public_path__ + "static/media/sms-icon.da6c24da8e3eba304fa694bb4955fab6.svg";
export { ForwardRef as ReactComponent };